<template>
  <div>
    <span v-if="booking.booking_number" class="is-flex align-center">
      {{ booking.booking_number }}
    </span>
    <span v-else-if="booking.rejected">
      <icon icon="close-outline" :size=".8" class="has-text-danger" />
    </span>
    <span v-else-if="!booking.booking_number && !booking.rejected">
      <icon icon="time" :size=".8" class="has-text-grey-light" />
    </span>
  </div>
</template>

<script>
export default {

  props: {
    booking: Object
  },

}
</script>
